// Helpers to refresh the mini cart (drawer) from Replo or any external script.
// Exposes two globals:
// - window.reploRefreshMiniCartAndOpen(): refresh sections and open the drawer
// - window.reploRefreshMiniCartSilently(): refresh sections without opening

(function () {
  function getSections() {
    return ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];
  }

  function fetchSections() {
    if (!window.Shopify || !window.Shopify.routes || !window.Shopify.routes.root) {
      return Promise.reject(new Error('Shopify routes not available'));
    }
    const sections = getSections();
    const url = `${window.Shopify.routes.root}cart?sections=${sections.join(',')}`;
    return fetch(url).then((r) => r.json());
  }

  function dispatchCartUpdated() {
    try {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: null } }));
    } catch (e) {
      // no-op
    }
  }

  function renderSilentlyFromData(data) {
    const sections = getSections();
    sections.forEach((id) => {
      const el = document.getElementById(id);
      const html = data[id];
      if (!el || !html) return;

      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const inner = parsed.querySelector('.shopify-section')?.innerHTML || html;
      el.innerHTML = inner;
    });
  }

  function renderWithMiniCartFromData(data) {
    const miniCart = document.querySelector('mini-cart');
    if (miniCart && typeof miniCart.renderContents === 'function') {
      miniCart.renderContents({ id: null, sections: data });
      return true;
    }
    return false;
  }

  window.reploRefreshMiniCartAndOpen = function reploRefreshMiniCartAndOpen() {
    return fetchSections()
      .then((data) => {
        if (!renderWithMiniCartFromData(data)) {
          renderSilentlyFromData(data);
        }
        dispatchCartUpdated();
      })
      .catch((e) => {
        console.error('[Replo] Failed to refresh mini cart:', e);
      });
  };

  window.reploRefreshMiniCartSilently = function reploRefreshMiniCartSilently() {
    return fetchSections()
      .then((data) => {
        renderSilentlyFromData(data);
        dispatchCartUpdated();
      })
      .catch((e) => {
        console.error('[Replo] Failed to silently refresh mini cart:', e);
      });
  };
})();

